module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/6daa0cd0c50ac000b03c92589fab81e5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Platinum/Platinum1.svg
// module id = spca
// module chunks = 1